import request from './AxiosRequest';

const joinGroup = (data) =>
    request({
        method: 'POST',
        url: '/Services/Api/UserGroup',
        data: data,
    });
const leaveGroup = (data) =>
    request({
        method: 'POST',
        url: '/Services/Api/UserGroup/Delete',
        data: data,
    });

const UserGroup = {
    joinGroup,
    leaveGroup
};

export default UserGroup;
